export type { ModalProps } from "./Modal";
export { Modal } from "./Modal";
